export default __webpack_public_path__ + "static/media/image-factory.792f1483.png";